import createCache from './createCache.esm.js';
import createFeatureFlagsClient from './createFeatureFlagsClient.esm.js';

var TYPE_NAME = 'FeatureFlag';

var createFeatureFlagsResolver = function createFeatureFlagsResolver(properties) {
  if (properties === void 0) {
    properties = {};
  }

  var cache = properties.cache || createCache();
  var featureFlagsClient = createFeatureFlagsClient(properties);
  return {
    Query: {
      featureFlags: function featureFlags(_, _ref) {
        var _featureFlags = _ref.featureFlags,
            allowlistValues = _ref.allowlistValues,
            trackingId = _ref.trackingId;
        return featureFlagsClient.get({
          featureFlags: _featureFlags,
          allowlistValues: allowlistValues,
          trackingId: trackingId
        }, cache).then(function (data) {
          return _featureFlags.map(function (featureFlag) {
            var _data$featureFlag;

            return {
              name: featureFlag,
              value: (_data$featureFlag = data[featureFlag]) != null ? _data$featureFlag : false,
              __typename: TYPE_NAME
            };
          });
        });
      }
    }
  };
};

export default createFeatureFlagsResolver;
//# sourceMappingURL=createFeatureFlagsResolver.esm.js.map
